/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMicOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m2.414 1 20 20L21 22.414 15.685 17.1a7.938 7.938 0 0 1-2.684.838L13 20h4v2H7v-2h4v-2.062C7.06 17.444 4 14.073 4 10h2a6.006 6.006 0 0 0 8.177 5.591l-1.63-1.628A4.004 4.004 0 0 1 8 10v-.586l-6.999-7zM20 10a7.96 7.96 0 0 1-1.683 4.903l-1.428-1.428A5.954 5.954 0 0 0 18 10zm-8-8c2.206 0 4 1.794 4 4v4c0 .741-.203 1.436-.555 2.032l-1.513-1.514A2.01 2.01 0 0 0 14 10V6c0-1.103-.897-2-2-2s-2 .897-2 2v.586L8.19 4.777A4.007 4.007 0 0 1 12 2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMicOff as MicOff };
